export const QueryKeys = {
  ME_QUERY: "me_query",
};
